import { TaskStatus, TaskTimeFilter } from 'constants/enums';
import store from 'store/storeConfig';

export const getTasksStatusOptions = () => {
  const { intl } = store.getState();
  return Object.values(TaskStatus)
    .filter((value) => value !== TaskStatus.ARCHIVED)
    .map((value) => {
      return {
        label: intl.messages[`tasks.status.${value}`],
        value: value
      };
    });
};

export const getTasksTimeOptions = () => {
  const { intl } = store.getState();
  return Object.values(TaskTimeFilter).map((value) => {
    return {
      label: intl.messages[`tasks.timeFilter.${value}`],
      value
    };
  });
};

export enum InterventionType {
  PATIENT = 'patient',
  CLINICAL = 'clinical'
}
